export default function Navigation() {
    nav()    
}

//
// Define your functions here
//
function nav() {

    var navMenuTrigger = document.querySelector(".mobile-menu-trigger");
    var navMenu = document.querySelector(".nav-icon");
    var menuBar = document.querySelector(".burger-nav");
    var topLevel = document.querySelectorAll('.main-menu');
    let scrollpos = window.scrollY;
    const header = document.getElementById("header");
    const header_height = header.offsetHeight;
    const navGreyStroke = document.querySelector(".nav-grey-stroke-bg");

    const add_class_on_scroll = () => header.classList.add("header-scroll");
    const remove_class_on_scroll = () => header.classList.remove("header-scroll");

    if (typeof (navMenuTrigger) != 'undefined' && navMenuTrigger != null &&
        typeof (navMenu) != 'undefined' && navMenu != null) {
        navMenuTrigger.onclick = function () {
            navMenu.classList.toggle('open');
            menuBar.classList.add('open');
            document.body.classList.add("stop-scrolling");
            header.classList.add("nav-open");
            navGreyStroke.classList.add("slide-left-with-bounce");
        }
    }

    var navMenuClose = document.querySelector(".header-close-icon");
    if (navMenuClose) {
        navMenuClose.addEventListener("click", function () {
            navMenu.classList.remove('open');
            menuBar.classList.remove('open');
            navGreyStroke.classList.remove("slide-left-with-bounce");
            var j;
            for (j = 0; j < topLevel.length; j++) {
                topLevel[j].classList.remove('show-secondary');
            }
            document.body.classList.remove("stop-scrolling");
            header.classList.remove("nav-open");
            navGreyStroke.classList.remove("slide-left");

            let allActiveMenus = menuBar.querySelectorAll('.active');

            allActiveMenus.forEach((item) => {
                item.classList.remove('active');
            });

            let allOpenedMenus = menuBar.querySelectorAll('.menu-open');
            allOpenedMenus.forEach((item) => {
                item.classList.remove('menu-open');
            });
                        
        });
    }

    var menuClose = document.querySelector(".burger-nav .bg");
    if (menuClose) {
        menuClose.addEventListener("click", function () {
            navMenu.classList.remove('open');
            menuBar.classList.remove('open');
            document.body.classList.remove("stop-scrolling");
        });
    }

    var mobileMenuDropdown = document.querySelectorAll(".nav-icon-wrapper");
    var i;

    if (mobileMenuDropdown) {
        for (i = 0; i < mobileMenuDropdown.length; i++) {
            mobileMenuDropdown[i].addEventListener("click", function () {
                // this.classList.toggle('active');
                var wrapper = this.parentElement.nextElementSibling;
                var dropdown = wrapper.querySelector('.sub-menu');

                if (dropdown.classList.contains("third-level")) {
                    dropdown.parentElement.classList.add("menu-open");
                }

                dropdown.classList.toggle('menu-open');
            });
        }
    }

    var desktopMenuDropdown = document.querySelectorAll(".menu-top");
    var j;

    if (desktopMenuDropdown) {
        for (j = 0; j < desktopMenuDropdown.length; j++) {
            desktopMenuDropdown[j].addEventListener("mouseenter", function (e) {

                desktopMenuDropdown.forEach(element => {
                    element.parentElement.classList.remove('active');

                    let thridLevel = element.parentElement.querySelector('.third-wrapper');

                    if (thridLevel) {
                        thridLevel.classList.remove('menu-open');
                        thridLevel.querySelector('.third-level').classList.remove('menu-open');
                    }
                });
                
                this.parentElement.classList.add('active');
                // var dropdown = this.parentElement.nextElementSibling;
                // dropdown.classList.toggle('menu-open');

            });
            // desktopMenuDropdown[j].addEventListener("mouseleave", function () {

            //     this.classList.toggle('active');
            //     var dropdown = this.parentElement.nextElementSibling;
            //     dropdown.classList.toggle('menu-open');
            // });
        }
    }

    var menuBack = document.querySelectorAll(".mobile-menu-back-link");
    if (menuBack) {
        for (i = 0; i < menuBack.length; i++) {
            menuBack[i].addEventListener("click", function () {
                var mainNav = this.parentElement.parentElement;

                if (this.classList.contains("third-back")) {
                    mainNav.parentElement.classList.remove('menu-open');
                }
                else {
                    mainNav.classList.remove('menu-open');
                }
            });
        }
    }

    var desktopMenuBack = document.querySelectorAll(".desktop-menu-back-link");
    if (desktopMenuBack) {
        for (i = 0; i < desktopMenuBack.length; i++) {
            desktopMenuBack[i].addEventListener("click", function () {
                if (this.classList.contains("third-back")) {
                    let parentLink = this.closest('.sub-menu');
                    if (!parentLink) return;
                    parentLink.classList.remove('menu-open');
                    parentLink.parentElement.classList.remove('menu-open');
                }
                else {
                    let parentLink = this.closest('.main-menu');
                    if (!parentLink) return;
                    parentLink.classList.remove('active');
                }
            });
        }
    }

    var secondaryMenu = document.querySelectorAll(".menu-list");
    var secondLevelLinks = document.querySelectorAll('.menu-list-link');
    var k;

    if (secondaryMenu) {
        for (k = 0; k < secondaryMenu.length; k++) {

            secondaryMenu[k].addEventListener("mouseleave", function () {


                for (const link of secondLevelLinks) {
                    link.classList.remove('white-hover');
                }
            });
        }
    }

    window.addEventListener('scroll', function () {
        scrollpos = window.scrollY;

        if (scrollpos >= header_height) { add_class_on_scroll() }
        else { remove_class_on_scroll() }

    });
}





